import { AccountSettingsEditRoute } from './-route-wrappers';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings/account/edit')({
  component: AccountSettingsEditRoute,
});
